(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rcopia-dosage', {
            parent: 'entity',
            url: '/rcopia-dosage',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'RcopiaDosages'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rcopia-dosage/rcopia-dosages.html',
                    controller: 'RcopiaDosageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('rcopia-dosage-detail', {
            parent: 'entity',
            url: '/rcopia-dosage/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'RcopiaDosage'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rcopia-dosage/rcopia-dosage-detail.html',
                    controller: 'RcopiaDosageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'RcopiaDosage', function($stateParams, RcopiaDosage) {
                    return RcopiaDosage.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'rcopia-dosage',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('rcopia-dosage-detail.edit', {
            parent: 'rcopia-dosage-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-dosage/rcopia-dosage-dialog.html',
                    controller: 'RcopiaDosageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RcopiaDosage', function(RcopiaDosage) {
                            return RcopiaDosage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rcopia-dosage.new', {
            parent: 'rcopia-dosage',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-dosage/rcopia-dosage-dialog.html',
                    controller: 'RcopiaDosageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dosageText: null,
                                patientNotes: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rcopia-dosage', null, { reload: 'rcopia-dosage' });
                }, function() {
                    $state.go('rcopia-dosage');
                });
            }]
        })
        .state('rcopia-dosage.edit', {
            parent: 'rcopia-dosage',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-dosage/rcopia-dosage-dialog.html',
                    controller: 'RcopiaDosageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RcopiaDosage', function(RcopiaDosage) {
                            return RcopiaDosage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rcopia-dosage', null, { reload: 'rcopia-dosage' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rcopia-dosage.delete', {
            parent: 'rcopia-dosage',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-dosage/rcopia-dosage-delete-dialog.html',
                    controller: 'RcopiaDosageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RcopiaDosage', function(RcopiaDosage) {
                            return RcopiaDosage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rcopia-dosage', null, { reload: 'rcopia-dosage' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
